import { Box } from '@material-ui/core';
import { getUsersByUserId, patchChangeUserId, UserId, UserType } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface SpyUserMessageProps {
  userId: string;
  userType: UserType;
  opened: boolean;
  setOpened: (boolean) => void;
  handleClose;
}

export const SpyUserMessage = ({ userId, userType, opened, setOpened, handleClose }: SpyUserMessageProps) => {
  const { request, loading } = useRequest();
  const { revalidate } = useCache(getUsersByUserId, { userId });
  const onSpyUser = async () => {
    await request(patchChangeUserId, { id: UserId.SPY, userId });
    handleClose();
    revalidate();
  };

  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton disabled={loading} onClick={handleClose}>
            <Text tId="CANCEL" />
          </StandardButton>
          <StandardButton main loading={loading} onClick={onSpyUser}>
            <Text tId={'SPY_USER'} />
          </StandardButton>
        </>
      }
    >
      <Box marginBottom={2}>
        <Font variant="h3" color="textPrimary">
          <Text tId={'SPY_USER'} />
        </Font>
      </Box>
      <Box pt={3}>
        <Font variant={'body1'} color={'textSecondary'}>
          <Text tId={`DO_YOU_WANT_TO_SPY_THIS_USER_${userType}`} />
        </Font>
      </Box>
    </NemuruDialog>
  );
};
